// extracted by mini-css-extract-plugin
export default {"root":"AccountSettings_root__HnkKU","alert":"AccountSettings_alert__zHl+M"};